import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { tap } from 'rxjs';

@Component({
  selector: 'app-ui-timepicker',
  templateUrl: './ui-timepicker.component.html',
  styleUrl: './ui-timepicker.component.scss',
  providers: [provideNativeDateAdapter()],
  standalone: false,
})
export class UiTimepickerComponent implements OnInit, OnChanges {
  @Input() label = '';
  @Input() control: FormControl<string | undefined>;
  @Input() description = '';
  @Input() required = true;

  @Output() readonly changeHandler: EventEmitter<string> = new EventEmitter<string>();

  timepickerControl = new FormControl();

  ngOnInit(): void {
    this.initTimepickerControl();

    this.timepickerControl.valueChanges
      .pipe(
        tap((value) => {
          // if (value && value instanceof Date && !Number.isNaN(value)) {
          //   const hours = value.getHours().toString().padStart(2, '0');
          //   const minutes = value.getMinutes().toString().padStart(2, '0');
          //   const formattedValue = `${hours}:${minutes}:00`;
          //   this.control.setValue(formattedValue, { emitEvent: false });
          // } else if (typeof value === 'string') {
          //   const [hours, minutes] = value.split(':').map(Number);
          //   const now = new Date();
          //   now.setHours(hours, minutes, 0, 0);
          //   this.control.setValue(now, { emitEvent: false });
          // }
          // if (value && value instanceof Date && !Number.isNaN(value)) {
          //   const hours = value.getHours().toString().padStart(2, '0');
          //   const minutes = value.getMinutes().toString().padStart(2, '0');
          //   const formattedValue = `${hours}:${minutes}:00`;
          //   this.control.setValue(formattedValue, { emitEvent: false });
          // }
          this.formatDateToTimeString(value);
        })
      )
      .subscribe();

    this.control.statusChanges
      .pipe(
        tap(() => {
          this.manangeTimepickerCtrlStatus();
        })
      )
      .subscribe();
  }

  ngOnChanges(): void {
    this.initTimepickerControl();
  }

  getValueAsDate(): Date {
    return this.timepickerControl.value;
  }

  private initTimepickerControl(): void {
    if (this.control.value && typeof this.control.value === 'string') {
      const [hours, minutes] = this.control.value.split(':').map(Number);
      const now = new Date();
      now.setHours(hours, minutes, 0, 0);
      this.timepickerControl.setValue(now, { emitEvent: false });
      this.manangeTimepickerCtrlStatus();
    }
  }

  private formatDateToTimeString(value: Date): void {
    if (value && value instanceof Date && !Number.isNaN(value)) {
      const hours = value.getHours().toString().padStart(2, '0');
      const minutes = value.getMinutes().toString().padStart(2, '0');
      const formattedValue = `${hours}:${minutes}:00`;
      this.control.setValue(formattedValue, { emitEvent: false });
      this.changeHandler.emit(formattedValue);
    }
  }

  private manangeTimepickerCtrlStatus(): void {
    if (this.control.status === 'DISABLED') {
      this.timepickerControl.disable();
    } else if (this.control.status === 'VALID') {
      this.timepickerControl.enable();
    }
  }
}
